import React, { Component, lazy, Suspense } from 'react';
import Modal from 'rc-dialog';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { ModalProps } from 'stores/ModalStore';
import EmailNewModalStore from 'stores/Modals/EmailNewModalStore';

import TagsSelect from 'components/TagsSelect/TagsSelect';
import Button from 'components/Button/Button';
import TextField from 'components/Form/Fields/Text/TextField';
import { bindFormControl } from 'components/Form/FormControl/FormControl';
import ModalHeader from 'components/Modals/Components/ModalHeader/ModalHeader';
import ModalBody from 'components/Modals/Components/ModalBody/ModalBody';
import ModalControls from 'components/Modals/Components/ModalControls/ModalControls';
import Spinner from 'components/Spinner/Spinner';

import style from './EmailNewModal.module.scss';

const RichTextEditor = lazy(() =>
  import('components/Form/Fields/RichTextEditor/RichTextEditor'),
);

@observer
class EmailNewModal extends Component<ModalProps> {
  private _store = new EmailNewModalStore();
  formControl = bindFormControl(this._store.form);

  componentDidMount() {
    this._store.init();
  }

  private _handleClose = () => {
    this.props.onClose();
  };

  private _handleSubmit = async () => {
    await this._store.submit(this.props.onClose);
  };

  render() {
    const FormControl = this.formControl;

    return (
      <Modal
        {...this.props}
        className={style.modal}
        destroyOnClose
        animation="zoom"
        maskAnimation="fade"
        visible
      >
        {this._store.isLoading && <Spinner contain />}

        <ModalHeader>
          <FormattedMessage id="modal.email.new.title" />
        </ModalHeader>

        <ModalBody>
          <div>
            <div className={style.tags}>
              <TagsSelect
                title="modal.email.new.groupTags.title"
                tags={this._store.userGroupTags}
                selectedTags={this._store.selectedUserGroupTags}
                isShowSearchField
                isShowSelectAll
                withGroups
                isShowTags={false}
                onResetAllTags={this._store.resetUserGroupTags}
                onSubmit={this._store.selectUserGroupTags}
                onRemoveTag={this._store.removeUserGroupTag}
              />
            </div>
            <div className={style.form__field}>
              <FormControl
                name="subject"
                render={propsField => <TextField {...propsField} />}
              />
            </div>
            <div className={style.form__field}>
              <FormControl
                name="contactEmail"
                render={propsField => <TextField {...propsField} />}
              />
            </div>
            <div className={style.form__field}>
              <Suspense fallback={<Spinner contain />}>
                <FormControl
                  name="message"
                  render={propsField => <RichTextEditor {...propsField} />}
                />
              </Suspense>
            </div>
          </div>
        </ModalBody>

        <ModalControls className={style.controls}>
          <>
            <Button
              className={style.btn}
              styleType="ghost"
              onClick={this._handleClose}
            >
              <FormattedMessage id="button.cancel" />
            </Button>

            <Button
              className={style.btn}
              styleType="primary"
              disabled={this._store.isSubmitDisabled}
              onClick={this._handleSubmit}
            >
              <FormattedMessage id="button.send" />
            </Button>
          </>
        </ModalControls>
      </Modal>
    );
  }
}

export default EmailNewModal;
